import { forwardRef, HTMLProps } from 'react';
import useHeadingManager from './useHeading';

type Props = HTMLProps<HTMLHeadingElement>;

export default forwardRef<HTMLHeadingElement, Props>(function Heading(props, ref) {
    const Component = useHeadingManager();
    return <Component ref={ref} {...props} />;
});
